import React, { useState, useEffect } from "react";
import ReusableModal from "components/ReusableModal";
import "./spaceModal.scss";
import {ExternalShare as ExternalShareSDK} from "@induz/sdk";
import { useToast } from "components/Toaster/index";

const ExternalSpaceModal = ({  handleCancel, selectedFolder,currentPath }) => {
  const [spaces, setSpaces] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedSpace, setSelectedSpace] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isAdding, setIsAdding] = useState(false);
  const showToast = useToast();
  // console.log("selected object in external space modal", selectedFolder);
//   console.log("is visible in external space modal", isVisible);
  // console.log("handle cancel in external space modal", handleCancel);
  // console.log("current path in external space modal", currentPath);
//   console.log("on space select in external space modal", onSpaceSelect);

  // Fetch spaces when modal becomes visible
  useEffect(() => {
    const fetchSpaces = async () => {
    //   if (!isVisible) return;
      
      try {
        // setIsLoading(true);
        // const dummySpaces = [
        //     { id: 1, name: "Development Team" },
        //     { id: 2, name: "Marketing" },
        //     { id: 3, name: "Design Studio" },
        //     { id: 4, name: "Project Alpha" },
        //     { id: 5, name: "Research Lab" }
        // ];
        const response= await ExternalShareSDK.listSpacesOfUser();
        const dummySpaces = response.map((space, index) => ({
            id: index + 1,
            name: space.getName()
        }));
        setSpaces(dummySpaces);
        // TODO: Replace with your API call
        // const response = await fetchAvailableSpaces();
        // setSpaces(response);
      } catch (error) {
        console.error("Failed to fetch spaces:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchSpaces();
  }, []);

  // Reset state when modal closes
//   useEffect(() => {
//     // if (!isVisible) {
//       setSearchQuery("");
//       setSelectedSpace(null);
//     // }
//   }, [isVisible]);

  // Filter spaces based on search
  const filteredSpaces = spaces.filter(space => 
    space.name.toLowerCase().includes(searchQuery.toLowerCase())
  );
const returnTypeOfPathForExternalSpace = (currentPathArray, selectedFolder) => {

    // console.log("current path array in returnTypeOfPathForExternalSpace", currentPathArray);
    if (currentPath.length==0 || currentPathArray[0]!="shared"){
        // TODO:rewrite all this hardcodig names and indices shit

        //  these are in all files

    //  return totalpath , type
        const totalPath = currentPathArray.join("/") + "/" + selectedFolder.name;
        return { path: totalPath, objectType: selectedFolder.type ,typeOfPath:"normal" };

    }

    //  if the object belongs to share
    // shared/self or shared/team_name
    let typeOfPath="shared_self";
        if (currentPathArray[1]!="self"){
            typeOfPath="shared_team";
        }
     if (currentPathArray.length==2){
         const totalPath=currentPathArray[0]+"/"+selectedFolder.uuids;
         
         return { path: totalPath, objectType: selectedFolder.type ,typeOfPath:typeOfPath};

     }
     const updatedPathArray=currentPathArray;
     updatedPathArray.splice(1,1);
        const totalPath=updatedPathArray.join("/") + "/" + selectedFolder.name;
        return { path: totalPath, objectType: selectedFolder.type ,typeOfPath:typeOfPath};
};

  const handleAddObjectToSpace = async () => {
    // console.log("adding object to space", selectedSpace);
    if (!selectedSpace || !selectedFolder || isAdding) return;
    
    setIsAdding(true);

    try {
      // Check if object already exists in the space
      const spaceList = await ExternalShareSDK.listSpacesOfUser();
      const targetSpace = spaceList.find(space => space.getName() === selectedSpace.name);
      
      if (targetSpace) {
        const existingObjects = targetSpace.getInfoOfSharedObjs() || [];
        const objectUuid = selectedFolder.uuids || selectedFolder.uuid;
        
        // Convert UUID to hex string format for comparison (same format as getUuid returns)
        let objectUuidHex = null;
        if (objectUuid) {
          if (objectUuid instanceof Uint8Array) {
            objectUuidHex = Array.from(objectUuid, byte => byte.toString(16).padStart(2, "0")).join("");
          } else if (typeof objectUuid === "string") {
            // If it's already a hex string, use it as is
            objectUuidHex = objectUuid;
          }
        }
        
        // Check if object with same UUID already exists
        const objectExists = existingObjects.some(obj => {
          const objUuid = obj.getUuid(); // Returns hex string
          if (objectUuidHex && objUuid) {
            return objUuid.toLowerCase() === objectUuidHex.toLowerCase();
          }
          // Fallback: check by name (less reliable but better than nothing)
          return obj.getName() === selectedFolder.name;
        });
        
        if (objectExists) {
          showToast("This object is already in the selected space", "error");
          setIsAdding(false);
          return;
        }
      }

      // Call returnTypeOfPathForExternalSpace and extract the values
      const { path, objectType, typeOfPath } = returnTypeOfPathForExternalSpace(currentPath, selectedFolder);
      
      await ExternalShareSDK.addObjectToSpace(objectType, typeOfPath, path, selectedSpace.name);
      showToast("Object added to space successfully", "success");
      handleCancel();
    } catch (error) {
      console.error("Failed to add object to space:", error);
      const errorMessage = error?.message || "Failed to add object to space. Please try again.";
      
      // Check for duplicate error in message
      if (errorMessage.toLowerCase().includes("duplicate") || 
          errorMessage.toLowerCase().includes("already exists") ||
          errorMessage.toLowerCase().includes("already in")) {
        showToast("This object is already in the selected space", "error");
      } else {
        showToast(errorMessage, "error");
      }
    } finally {
      setIsAdding(false);
    }
  };

  return (
    <ReusableModal handleCancel={handleCancel} width="500px">
      <div className="AddSpaceModal" onClick={(e) => e.stopPropagation()}>
        <div className="ModalHeader">
          <h3>Add to Space</h3>
          <div className="cross" onClick={handleCancel}>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <path d="M16.5 5.5L5.5 16.5M5.5 5.5L16.5 16.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
        </div>
        <div className="ModalBody">
          <div className="space-select-container">
            <div className="search-section">
              <div className="search-row">
                <svg className="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="currentColor"/>
                </svg>
                <input
                  type="text"
                  className="space-search-input"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search spaces..."
                />
              </div>
            </div>

            <div className="spaces-list">
              {isLoading ? (
                <div className="loading">Loading available spaces...</div>
              ) : filteredSpaces.length === 0 ? (
                <div className="no-spaces">No spaces found</div>
              ) : (
                filteredSpaces.map((space) => (
                  <div
                    key={space.id}
                    className={`space-item ${selectedSpace?.id === space.id ? "selected" : ""}`}
                    onClick={() => setSelectedSpace(space)}
                  >
                    <div className="space-icon">
                      {space.name.charAt(0).toUpperCase()}
                    </div>
                    <div className="space-details">
                      <div className="space-name">{space.name}</div>
                    </div>
                    {/* <div className="checkmark-icon">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                        <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </div> */}
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
        <div className="ModalFooter">
          <button className="SecondaryButton" onClick={handleCancel}>
            Cancel
          </button>
          <button
            className="PrimaryButton"
            onClick={handleAddObjectToSpace}
            disabled={!selectedSpace || isAdding}
          >
            {isAdding ? "Adding..." : "Add"}
          </button>
        </div>
      </div>
    </ReusableModal>
  );
};

export default ExternalSpaceModal;